const NEXT_ENV = process.env.NEXT_PUBLIC_ENV;

const environment = {
  value: NEXT_ENV,
  isProduction: NEXT_ENV === 'production',
  isStaging: NEXT_ENV === 'staging',
};

export default environment;
